const state = {
  accessories: [],
  accessoriesListInfo: [],
  accessoriesToDestroy: [],
}

if(Spree.accessories_info){
  state.accessoriesListInfo = Spree.accessories_info.map((accessory, idx) => {
    return {
      ...accessory,
      quantity: "1",
      selected: false,
      index: idx,
      selected_variant: _.cloneDeep(accessory.variants.length > 0 ? accessory.variants[0] : accessory.master),    
    }
  });
}

export default state;